import axios from 'axios';
import index from './index';
export default {
  load() {
    return axios.get(`/modules/${index.api}/`);
  },
};
